import { useStore } from 'vuex'
import { onMounted, computed, ref } from 'vue'
import { useTabTrap } from 'foundation/js/useTabTrap'
import formatNewlines from 'foundation/js/formatNewlines'

export default {
    name: 'MemberListOverlayCancerforum',
    emits: ['setTabTargets'],
    props: {
        groupId: {
            type: String,
            required: true
        }
    },
    setup(props, { emit }) {
        const store = useStore()
        const overlayRef = ref(null)

        const toggleAccordion = function (e) {
            const isExpanded = !!(
                e.currentTarget.getAttribute('aria-expanded') === 'true'
            )
            const accordionTarget = document.querySelector(
                `#${e.currentTarget.getAttribute('aria-controls')}`
            )
            const chevronTarget = e.currentTarget.querySelector(
                '.kb-member-list-overlay__member-chevron'
            )

            chevronTarget.classList[isExpanded ? 'remove' : 'add'](
                'kb-member-list-overlay__member-chevron--open'
            )
            accordionTarget.classList[isExpanded ? 'remove' : 'add'](
                'kb-member-list-overlay__content--open'
            )
            e.currentTarget.setAttribute(
                'aria-expanded',
                isExpanded ? 'false' : 'true'
            )

            accordionTarget.querySelectorAll('a').forEach((a) => {
                if (isExpanded) {
                    a.setAttribute('tabindex', -1)
                } else {
                    a.removeAttribute('tabindex')
                }
            })
        }

        const { setTabTargets, tabTrap } = useTabTrap(overlayRef, emit)

        const isSubmitting = computed(() => store.state.forum.is_submitting)

        const groupId = computed(() => props.groupId ?? store.state.main.page_overlay_content_data.groupId
        )

        const memberListData = computed(() => {return store.state.forum.member_list_data})

        const showLoadMoreMembersButton = computed(() => {
            if (!memberListData.value?.memberList.length) {
                return false
            }
            return (
                memberListData.value?.memberList.length <
                store.state.forum.member_list_data.totalHits
            )
        })

        const skip = ref(0)
        const take = ref(10)
        const fetchGruppemedlemmer = function () {
            store.dispatch('forum/getMemberListData', {
                id: groupId.value,
                skip: skip.value,
                take: take.value
            })
            .then(() => {
                setTabTargets()
            })
        }

        const loadMore = function() {
            skip.value = take.value + skip.value
            fetchGruppemedlemmer()
        }

        onMounted(() => {
            fetchGruppemedlemmer()
        })

        const getLabel = (labelKey, strings) => {
            let label = store.getters['labels/getLabel']({
                labelCollection: 'MemberListOverlayCancerforum',
                labelKey
            })

            if (strings) {
                strings.forEach((str, index) => {
                    label = label.replace(`{${index}}`, str)
                })
            }

            return label
        }

        return {
            showLoadMoreMembersButton,
            memberListData,
            toggleAccordion,
            overlayRef,
            getLabel,
            loadMore,
            tabTrap,
            isSubmitting,
            formatNewlines
        }
    }
}